import { Configuration as AuthConfigOptions } from '@azure/msal-browser';
import AuthConfig from './auth';
import CommonConfig, { CommonConfigOptions } from './common';

export interface ConfigOptions extends CommonConfigOptions {
  application: string;
  pliUrl: string;
  apiUrl: string;
  companyUrl: string;
  gaTrackingId: string;
  supportEmail: string;
  wmUrl: string;
  copyrightEmail: string;
  digitalProductSupportUrl: string;
  auth: AuthConfigOptions;
}

const Config: ConfigOptions = {
  ...CommonConfig,
  auth: AuthConfig,
  application: process.env.REACT_APP_APP_NAME as string,
  apiUrl: process.env.REACT_APP_API_URL as string,
  pliUrl: process.env.REACT_APP_PLI_URL as string,
  companyUrl: process.env.REACT_APP_COMPANY_URL as string,
  wmUrl: process.env.REACT_APP_WM_URL as string,
  digitalProductSupportUrl: process.env.REACT_APP_SUPPORT_URL_DIGITAL_PRODUCT as string,
  copyrightEmail: process.env.REACT_APP_COPYRIGHT_EMAIL as string,
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL as string,
  gaTrackingId: process.env.REACT_APP_GA_TRACKING_ID as string
};

export default Config;
